// GroundOps Marketing Website
import { Routes, Route } from 'react-router-dom'
import Landing from './landing/Landing'
import PrivacyPolicy from './legal/PrivacyPolicy'
import Support from './legal/Support'
import SignupRedirect from './components/SignupRedirect'
import GetApp from './components/GetApp'
import AllocationList from './spikes/allocation/AllocationList'
import AllocationDetail from './spikes/allocation/AllocationDetail'
import DesignSystem from './spikes/design-system/DesignSystem'
import RouteManager from './spikes/route-manager/RouteManager'
import GoogleEarth from './spikes/google-earth/GoogleEarth'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      {/* Public legal/support pages — registered in App Store Connect (#336) */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/support" element={<Support />} />
      {/* Stable public signup URL → the web app's self-serve org creation (#830 B1) */}
      <Route path="/signup" element={<SignupRedirect />} />
      {/* Stable public app-download URL — phones redirect to their store; the
          invite email's QR + link point here (see lib/app-links.ts) */}
      <Route path="/get" element={<GetApp />} />
      {/* Every remaining spike is DEVELOPMENT ONLY (#449), for the same reason
          #1659 removed the route manager: these are internal prototypes that
          were reachable on the public marketing site.

          Measured on the shipped production bundle before this change —
          `/spikes/allocations` 4 occurrences, `/spikes/design-system` 1,
          `/spikes/google-earth` 1, against controls `/privacy` 4 and
          `/spikes/nonexistent` 0. A status code cannot tell you this: www is
          an SPA, so every path returns the shell and even a nonexistent route
          answers 200. The bundle is the authority.

          None is linked from the landing page or the nav — they are reachable
          only by typing the URL — and none is marked "explicitly approved" per
          #449's own criterion, so removing them from production costs nothing.

          The design-system references in CLAUDE.md and docs/DESIGN-SYSTEM.md
          point at `src/app`'s copy, which is untouched; this is www's separate
          duplicate. */}
      {import.meta.env.DEV && (
        <>
          <Route path="/spikes/allocations" element={<AllocationList />} />
          <Route path="/spikes/allocations/:id" element={<AllocationDetail />} />
          <Route path="/spikes/design-system" element={<DesignSystem />} />
        </>
      )}
      {/* Route manager is DEVELOPMENT ONLY (#1659).

          It rendered OSM tiles on a public production route, while the web app
          classes OSM `commercial: false` and refuses it in a production build
          (src/app/src/lib/basemap). That split was accidental, not a policy:
          the same tiles were licensed one way in one bundle and another way in
          the other. **OSM is now development-only everywhere.**

          Removing it from production costs nothing, which is what makes this
          the smallest sound fix rather than a trade-off:
            · it is linked from NOWHERE — reachable only by typing the URL;
            · App.tsx renders `<RouteManager />` with NO PROPS, and the
              component guards on `if (!pitsUrl) return`, so the public page is
              an empty shell that cannot load pits, upload a PDF or persist
              anything;
            · its real entry point is `standalone.tsx`, which reads config from
              `data-*` attributes — it was built to embed in the retired Rails
              app, not to be served here.

          The component stays: docs/network-intelligence cites it as the
          precedent for the digitisation workspace, and it is slated for
          productisation onto MapLibre (proposed-02). This removes a public
          unlicensed-tile surface, not the reference implementation. */}
      {import.meta.env.DEV && (
        <Route path="/spikes/route-manager" element={<RouteManager />} />
      )}
      {import.meta.env.DEV && (
        <Route path="/spikes/google-earth" element={<GoogleEarth />} />
      )}
      <Route path="*" element={<Landing />} />
    </Routes>
  )
}

export default App
